import React from 'react'
import { Link } from 'react-router-dom';
import Footer from '../components/layout/Footer';
import Header from '../components/layout/Header';
import PageIntro from '../components/PageIntro';

export default function Policy() {
    return (
        <>
        <Header />
        <PageIntro intro="Disclaimer" design="pages-head1" title="This disclaimer of Myschoolgateway." />
            <section id="contact-p1" className="contact-p1"> 
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>Personal identification information</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                    We may collect personal identification information from Users in a variety of ways, including, but not limited to, when Users visit our site, respond to a survey, and in connection with other activities, services, features or resources we make available on our Site. Users may be asked for, as appropriate, name, email address. Users may, however, visit our Site anonymously. We will collect personal identification information from Users only if they voluntarily submit such information to us. Users can always refuse to supply personally identification information, except that it may prevent them from engaging in certain Site related activities.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>Non-personal identification information</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                We may collect non-personal identification information about Users whenever they interact with our Site. Non-personal identification information may include the browser name, the type of computer and technical information about Users means of connection to our Site, such as the operating system and the Internet service providers utilized and other similar information.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>Web browser cookies</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                Our Site may use "cookies" to enhance User experience. User's web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. User may choose to set their web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the Site may not function properly.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>How we use collected information</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                    https://www.myschoolgateway.com may collect and use Users personal information for the following purposes:
                                    To run and operate our Site
                                    We may need your information display content on the Site correctly.To improve customer service
                                    Information you provide helps us respond to your customer service requests and support needs more efficiently.To personalize user experience
                                    We may use information in the aggregate to understand how our Users as a group use the services and resources provided on our Site.To improve our Site
                                    We may use feedback you provide to improve our products and services.To run a promotion, contest, survey or other Site feature
                                    To send Users information they agreed to receive about topics we think will be of interest to them.To send periodic emails
                                    We may use the email address to send User information and updates pertaining to their order. It may also be used to respond to their inquiries, questions, and/or other requests.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>How we protect your information</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our Site.
                                Sharing your personal information
                                We may share or sell information with third parties for marketing or other purposes.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>Third party websites</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                Users may find advertising or other content on our Site that link to the sites and services of our partners, suppliers, advertisers, sponsors, licensors and other third parties. We do not control the content or links that appear on these sites and are not responsible for the practices employed by websites linked to or from our Site. In addition, these sites or services, including their content and links, may be constantly changing. These sites and services may have their own privacy policies and customer service policies. Browsing and interaction on any other website, including websites which have a link to our Site, is subject to that website's own terms and policies.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>Advertising</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                Ads appearing on our site may be delivered to Users by advertising partners, who may set cookies. These cookies allow the ad server to recognize your computer each time they send you an online advertisement to compile non personal identification information about you or others who use your computer. This information allows ad networks to, among other things, deliver targeted advertisements that they believe will be of most interest to you. This privacy policy does not cover the use of cookies by any advertisers.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>Google Adsense</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                Some of the ads may be served by Google. Google's use of the DART cookie enables it to serve ads to Users based on their visit to our Site and other sites on the Internet. DART uses "non personally identifiable information" and does NOT track personal information about you, such as your name, email address, physical address, etc. You may opt out of the use of the DART cookie by visiting the Google ad and content network privacy policy at <a href="http://www.google.com/privacy_ads.html">www.google.com/privacy_ads.html</a>
                                {/* <h4>Compliance with children's online privacy protection act</h4>
                                Protecting the privacy of the very young is especially important. For that reason, we never collect or maintain information at our Site from those we actually know are under 13, and no part of our website is structured to attract anyone under 13. */}
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>Changes to this privacy policy</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                    https://www.myschoolgateway.com has the discretion to update this privacy policy at any time. When we do, we may post a notification on the main page of our Site, revise the updated date at the bottom of this page and send you an email. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. You acknowledge and agree that it is your responsibility to review this privacy policy periodically and become aware of modifications.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>Your acceptance of these terms</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                    By using this Site, you signify your acceptance of this policy. If you do not agree to this policy, please do not use our Site. Your continued use of the Site following the posting of changes to this policy will be deemed your acceptance of those changes. This policy was generated using <a href="http://privacypolicies.com">privacypolicies.com</a>
                                </p>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3>Contacting us</h3>
                                <div className="heading-border-light"></div> 
                                <p>
                                If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please <Link to="/contact-us">contact us</Link>.<br/><br/>
                                <samp style={{color:"red"}}>This document was last updated on October 01, 2018.</samp>
                                </p>
                            </div>
                        </div>

                        {/* <div className="col-md-12">
                            <div className="contact-p1-cont">
                                <h3></h3>
                                <div className="heading-border-light"></div> 
                                <p>

                                </p>
                            </div>
                        </div> */}

                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}
